module.exports = __webpack_public_path__ + "static/media/ngo-npo.eac1471e.jpg";